// extracted by mini-css-extract-plugin
export var apiV2ReleaseNotesDescription = "api-v2-release-notes__description_uszHCN9E4LaIEt0I3aRc";
export var apiV2ReleaseNotesDetails = "api-v2-release-notes__details_PVJfD9owinGsa_14CKkQ";
export var apiV2ReleaseNotesEditButton = "api-v2-release-notes__edit-button_F9nhiq8MfojHagCLtHEQ";
export var apiV2ReleaseNotesEditableItem = "api-v2-release-notes__editable-item_ljHmfgflo5aE5pgvE90Q";
export var apiV2ReleaseNotesRemovableItem = "api-v2-release-notes__removable-item_l_J7iP5IQFZAE9KjgRVC";